import UploadOrMailComponent from './UploadOrMailContainer';

export default UploadOrMailComponent;
